import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommunityPassportsComponent } from './components/community-passports/community-passports.component';
import { PassportComponent } from './components/passport/passport.component';
import { ProfileComponent } from './components/profile/profile.component';
import { SpotlightEventStampComponent } from './components/spotlight-event-stamp/spotlight-event-stamp.component';
const routes: Routes = [
  {
    path: '',
    component: PassportComponent,
    children: [
      {
        path: '',
        component: ProfileComponent,
      },
      {
        path: 'community/:userId',
        data: { readonly: true },
        component: ProfileComponent
      },
      {
        path: 'event',
        component: SpotlightEventStampComponent,
      },
      {
        path: 'community',
        component: CommunityPassportsComponent
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PassportRoutingModule {}
